module.exports = __webpack_public_path__ + "static/media/musgrave.cd653bbb.png";